function Footer() {
	const footerNav = document.querySelector('[data-footer-nav]')
	const column1 = document.querySelector('[data-footer-column-1]')
	const column2 = document.querySelector('[data-footer-column-2]')

	const menusContainer = document.querySelector('[data-footer-menus]')
	const menus = document.querySelectorAll('[data-footer-menu]')

	const menu1 = document.querySelector('[data-footer-menu="1"]')
	const menu2 = document.querySelector('[data-footer-menu="2"]')
	const menu3 = document.querySelector('[data-footer-menu="3"]')
	const menu4 = document.querySelector('[data-footer-menu="4"]')

	const form = document.querySelector('[data-footer-form]')
	const recaptcha = footerNav.querySelector('.gfield--type-captcha')
	const recaptchaColumn = recaptcha
		? recaptcha.closest('[data-footer-menu]')
		: null
	const recaptchaWidth = 302

	let formContainer = null

	// Require at least these elements
	if (!column1 || !column2 || !menusContainer || !menus) return

	// If a form exists, recall its original position so it can be moved back if necessary
	if (form) {
		formContainer = form.parentElement
	}

	// Establish breakpoints where an adjustment must be made
	const tabletBreakpoint = 1001
	const mobileBreakpoint = 680

	// And determine breakpoint we're in, as the page loads
	let layout = null

	function getBreakpoint() {
		// const width = footerNav.getBoundingClientRect().width
		const width = window.innerWidth

		if( width > tabletBreakpoint) return 'desktop'
		return width < mobileBreakpoint
			? 'mobile'
			: 'tablet'
	}

	// DESKTOP
	function layoutDesktop() {
		
		Object.keys(menus).forEach((index) => {
			const menu = menus[index]
			menusContainer.appendChild(menu)
		})

		menu2.insertAdjacentElement('afterend', menu3)
		// menu3.insertAdjacentElement('afterend', menu4)

		// Restore the form to its original position
		menu4.appendChild(form)

		layout = 'desktop'
	}

	// TABLET
	function layoutTablet() {
		menu2.appendChild(menu3)
		
		// Insert 4 after 2, because 3 is currently in 2
		menu2.insertAdjacentElement('afterend', menu4)

		// Restore the form to its original position
		menu4.appendChild(form)

		layout = 'tablet'
	}

	// MOBILE
	function layoutMobile() {
		menu3.appendChild(menu4)
		// menu3.insertAdjacentElement('afterend', menu4)
		
		// Put the form in its own new row, below a pair of nav columns
		menusContainer.insertAdjacentElement('afterend', form)
		
		layout = 'mobile'
	}

	function scaleRecaptcha() {
		const breakpoint = getBreakpoint()

		if( breakpoint === 'mobile') {
			recaptcha.style = ''
			return
		}

		const {width} = recaptchaColumn.getBoundingClientRect()
		const scale = Math.min(1, width / recaptchaWidth)
		recaptcha.style.transform = `scale(${scale})`
		recaptcha.style.transformOrigin = 'left'
	}

	function handleResize() {

		const breakpoint = getBreakpoint()

		switch(breakpoint) {
			case 'desktop': 
				if (layout !== 'desktop') layoutDesktop()
			break;
			case 'tablet': 
				if (layout !== 'tablet') layoutTablet()
			break;
			case 'mobile': 
				if (layout !== 'mobile') layoutMobile()
			break;
		}

		if( recaptcha && recaptchaColumn ) {
			scaleRecaptcha()
		}
	}

	function handleLoad() {
		const breakpoint = getBreakpoint()
		
		switch(breakpoint) {
			case 'desktop': 
				layoutDesktop()
			break;
			case 'tablet': 
				layoutTablet()
			break;
			case 'mobile': 
				layoutTablet()
				layoutMobile()
			break;
		}

		if( recaptcha && recaptchaColumn ) {
			scaleRecaptcha()
		}
	}

	window.addEventListener('resize', handleResize)

	handleLoad()
}

export default Footer
